import React, { useState, useEffect } from "react";
import PropTypes from 'prop-types';
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";

//i18n
import { withTranslation } from "react-i18next";
// Redux
import { connect } from "react-redux";
import { withRouter, Link } from "react-router-dom";

// users
import user1 from "../../../assets/images/users/avatar-1.jpg";

import CryptoJS from 'crypto-js';
import useDecryptedAuth from "../../../Utils/useDecryptedAuth";


const ProfileMenu = props => {
  // Declare a new state variable, which we'll call "menu"
  const [menu, setMenu] = useState(false);
  const decryptedAuth = useDecryptedAuth();


  const [username, setusername] = useState({fullname: 'Admin', symbol: 'A'});
  React.useEffect(() => {
    let capitalizedUsername = decryptedAuth.username.replace(/\b\w/g, function(char) {
        return char.toUpperCase();
    });

    let words = decryptedAuth.username.split(' ');
    let firstCharacters = words.map(word => word.charAt(0).toUpperCase());
    let combined = firstCharacters.join('');

    setusername({
      ...username,
      fullname: capitalizedUsername,
      symbol: combined,
    });
  }, []);


  return (
    <React.Fragment>
      <Dropdown
        isOpen={menu}
        toggle={() => setMenu(!menu)}
        className="d-inline-block"
      >
        <DropdownToggle
          className="btn header-item "
          id="page-header-user-dropdown"
          tag="button"
        >
          {/* <img
            className="rounded-circle header-profile-user"
            src={user1}
            alt="Header Avatar"
          /> */}
          <span className="name-logo">{username.symbol}</span>

          <span className="d-none d-xl-inline-block ms-2 me-1">{username.fullname}</span>
          <i className="mdi mdi-chevron-down d-none d-xl-inline-block" />
        </DropdownToggle>
        <DropdownMenu className="dropdown-menu-end">
          <Link to="/profile" className="dropdown-item"> <i className="bx bx-user font-size-16 align-middle me-1" />{props.t("Profile Settings")}</Link>
          <Link to="/changepassword" className="dropdown-item"> <i className="bx bx-lock font-size-16 align-middle me-1" />{props.t("Change Password")}</Link>

          <div className="dropdown-divider" />

          <Link to="/logout" className="dropdown-item">
            <i className="bx bx-power-off font-size-16 align-middle me-1 text-danger" />
            <span>{props.t("Logout")}</span>
          </Link>
        </DropdownMenu>
      </Dropdown>
    </React.Fragment>
  );
};

ProfileMenu.propTypes = {
  success: PropTypes.any,
  t: PropTypes.any
};

const mapStatetoProps = state => {
  const { error, success } = state.Profile;
  return { error, success };
};

export default withRouter(
  connect(mapStatetoProps, {})(withTranslation()(ProfileMenu))
);
